import { useCallback, useEffect, useState } from 'react'

export default function useScroll(threshold:any) {
  const [scrolled, setScrolled] = useState(false)

  const onScroll = useCallback(() => {
    setScrolled(window.pageYOffset > threshold)
  }, [threshold])

  useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [onScroll])

  return scrolled
}
